import script from "./GuidePage.vue?vue&type=script&setup=true&lang=js"
export * from "./GuidePage.vue?vue&type=script&setup=true&lang=js"

import "./GuidePage.vue?vue&type=style&index=0&id=6306c046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6306c046"]])

export default __exports__